import PlataformaService from 'services/PlataformaService'
import { PlataformasProps } from './types'
import { getRandomImage } from 'utils/image'
import { Plataforma } from 'store/slices/types'
import { appInsights } from 'config/appInsights'
import { Exception } from '@microsoft/applicationinsights-web'

export interface LoadPlataformasProps {
  ignorarPermissao?: boolean
  buscarPrivados?: boolean
}

const loadPlataformas = async ({
  ignorarPermissao,
  buscarPrivados
}: LoadPlataformasProps) => {
  const listaPlataformas = (await PlataformaService.getPlataformas({
    ignorarPermissao,
    buscarPrivados
  })) as PlataformasProps[]
  const listaComImagens = listaPlataformas.map(plataforma =>
    !plataforma.codigoIconeDark || !plataforma.codigoIconeLight
      ? {
          ...plataforma,
          codigoIconeDark: getRandomImage(),
          codigoIconeLight: getRandomImage()
        }
      : plataforma
  )
  return listaComImagens
}

const getPlataforma = async (codigoPlataforma: string): Promise<Plataforma> => {
  try {
    const plataforma = await PlataformaService.getPlataforma(codigoPlataforma)
    return plataforma as Plataforma
  } catch (error) {
    appInsights.trackException(error as Exception)
    throw error
  }
}

export { loadPlataformas, getPlataforma }
